import { createSlice } from '@reduxjs/toolkit';
import { findReferralSummary } from './api';
import { initialState } from './api/interface';

const referralSummarySlice = createSlice({
  name: 'referralSummary',
  initialState,
  reducers: {
    setStatus: (state, action) => {
      state.status = action.payload.status;
    },
    reset: () => initialState,
  },
  extraReducers: (builder) => {
    builder.addCase(findReferralSummary.pending, (state) => {
      state.isLoading = true;
      state.status = 'pending';
    });
    builder.addCase(findReferralSummary.fulfilled, (state, action) => {
      state.data = action.payload || null;
      state.isError = false;
      state.isSuccess = true;
      state.isLoading = false;
      state.status = 'succeeded';
    });
    builder.addCase(findReferralSummary.rejected, (state) => {
      state.data = null;
      state.isLoading = false;
      state.isError = true;
      state.isSuccess = false;
      state.status = 'failed';
    });
  },
});

export const { setStatus, reset } = referralSummarySlice.actions;
export default referralSummarySlice.reducer;
